<span class="label">{{ label() }}</span>

<ng-content />
